import { SportEventsNewQueryKeys } from "./sportEventsNewQueryKeys";
import type { FeedType } from "@/types/SportsApiResponses";

// Value imports here are relative on purpose: this file is unit-tested and the
// repo has no vitest alias for "@/", so a "@/" value import would not resolve
// under vitest (type imports are erased and are fine).

export interface SingleSportEventQueryOptions {
  id: number | string;
  feedType: FeedType;
  providerId: number | string;
  statusFallback?: "sr";
}

/**
 * Pure: the react-query key of one sport event. The trailing element is the
 * status fallback (null when not requested) so a coupon row asking for the
 * Sportradar clock never shares a cache entry with a match page for the same
 * id, which asks for the full event and gets null while the leg's provider
 * has no live entry.
 */
export const buildSingleSportEventKey = (
  locale: string,
  queryOptions: SingleSportEventQueryOptions
) =>
  [
    SportEventsNewQueryKeys.Single,
    locale,
    queryOptions.feedType,
    queryOptions.id,
    queryOptions.providerId,
    queryOptions.statusFallback ?? null,
  ] as const;
